import useLink from "qpr-base/hooks/useLink";
import React from "react";

import { IconButton } from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";
import { ICardElementWithChildren } from "backend/model/model";
import typeToView from "routing/typetoview";

const ElementLink = (
  props: React.PropsWithChildren<{ item?: ICardElementWithChildren }>
) => {
  const { item } = props;
  const link = useLink();

  if (!item) return null;

  return (
    <IconButton
      onClick={() => {
        link({
          meaId: item.id,
          page: typeToView(item.typename),
          period:
            item.workflowState?.period ||
            item.workflowInstance?.period ||
            item.period?.name,
        });
      }}
    >
      <LinkIcon />
    </IconButton>
  );
};

export default ElementLink;
